/* @flow */
import * as React from 'react';
import RequireUser from 'lib/RequireUser';
import RequireSetup from 'lib/RequireSetup';
import RequireDesktop from 'lib/RequireDesktop';
import { IndexRoute, Route, IndexRedirect } from 'react-router';
import chainOnEnter from 'components/lib/chainOnEnter';
import OrganizationPage from 'organizations/components/OrganizationPage';
import OrganizationRedirect from 'organizations/components/OrganizationRedirect';
import OrganizationUpsellPage from 'organizations/components/OrganizationUpsellPage';
import OrganizationAnnouncementsContainer from 'organizations/components/OrganizationAnnouncementsContainer';

const requireLoggedIn = chainOnEnter([RequireUser, RequireSetup, RequireDesktop]);

export default (
  <Route path="/organizations(/)" onEnter={requireLoggedIn}>
    <IndexRedirect to="/classes" />

    <Route path=":id(/)">
      <Route component={OrganizationPage}>
        <Route path="announcements" component={OrganizationAnnouncementsContainer} />
      </Route>
      <Route path="features" component={OrganizationUpsellPage} />
      <Route path="*" component={OrganizationRedirect} />
      <IndexRoute component={OrganizationRedirect} />
    </Route>
  </Route>
);
